module.exports = __webpack_public_path__ + "img/icon_home_ai_icon_13.b4804181.png";